/**
stats-fishing
*/


<template>
    <div>
        <div id="top-ten-demersal-rates"></div>
    </div>
</template>


<script>
import store from "../store/reality-check-store";


export default {
    name: "stats-fishing",
    components: {},
    store,
    props: {
        stateChange: {type: Number, required: true}  // to trigger redraw
    },
    data: function () {
        return {}
    },
    methods: {
        drawFishingChart: function () {
            const layout = {
                showlegend: false,
                autosize: true,
                margin: {
                    // t: 60, r: 10, b: 40, l: 80
                    b: 180
                },
                title: "10 MPAs with the highest fishing rate<br>(average hours/year/km<sup>2</sup> over 2015-20)",
                yaxis: {
                    title: "Fishing rate (hours/year/km<sup>2</sup>)",
                    tickformat: ',.0f',
                }
            }

            if (window.innerWidth >= 1023) {
                layout.font = {size: 12}
            } else {
                layout.font = {size: 10}
            }

            Plotly.newPlot("top-ten-demersal-rates", [this.demersalFishingData], layout, {responsive: true})
        }
    },
    computed: {
        demersalFishingData: function () {
            return this.$store.state.stats.demersalFishingData;
        },
    },
    watch: {
        demersalFishingData: function () {
            if (this.demersalFishingData) {
                this.drawFishingChart()
            }
        },
        stateChange: function () {
            this.drawFishingChart()
        }
    },
    mounted: function () {
    }
}
</script>


<style lang="scss">
    @import "../../../styles/variables.scss";

</style>